import { has } from 'lodash'

export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE'

export const setCurrentPage = page => ({
  type: SET_CURRENT_PAGE,
  payload: page,
})

export const configurePagination = seachParams => dispatch => {
  const page = parseInt(seachParams.page, 10)
  if (has(seachParams, 'page') && Number.isInteger(page)) {
    dispatch(setCurrentPage(page))
  }
}
